import React from "react";
import Navbar from "@/components/Navbar";
import HomePartnerComponent from "@/components/HomePartner";
import Footer from "@/components/Footer";
import { PropertyCorrectionsProvider } from "@/contexts/PropertyCorrectionsContext";

const HomePartner = () => {
  return (
    <PropertyCorrectionsProvider>
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-1">
          <HomePartnerComponent />
        </main>
        <Footer />
      </div>
    </PropertyCorrectionsProvider>
  );
};

export default HomePartner;
